import { useQuery } from "@tanstack/react-query";
import { ErrorResponse } from "App";
import { errorModal } from "modules/error/ErrorHandlingModals";

import { getUserDetailsService } from "../api";

export const useGetUserDetailsQuery = (id: string) => {
  const query = useQuery({
    queryKey: ["user-details", id],
    queryFn: () => getUserDetailsService(id),
    enabled: id !== "" && id !== undefined,
    onError: (error: ErrorResponse) => errorModal(error),
    useErrorBoundary: true
  });
  return query;
};
